var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-highlights"},_vm._l((_vm.crossbreedingHighlightsPositions),function(highlightPosition,index){return _c('div',{key:index,staticClass:"input-highlights_gene-highlight",class:{ 'input-highlights_gene-highlight--for-base': highlightPosition.isBase },style:({
      top: `calc(var(--gene-ta-gutter-top, 0px) + ${highlightPosition.position} * var(--gene-ta-line-height, 1.3775rem))`
    })},[_vm._v(" "+_vm._s(highlightPosition.saplingGeneString)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }